"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProps = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var icon_secondary_module_scss_1 = __importDefault(require("./icon-secondary.module.scss"));
exports.defaultProps = {
    variant: 'gray-dark',
    size: 'medium'
};
function Icon(_a) {
    var children = _a.children, className = _a.className, _b = _a.size, size = _b === void 0 ? exports.defaultProps.size : _b, ariaLabel = _a.ariaLabel, ariaHidden = _a.ariaHidden, _c = _a.role, role = _c === void 0 ? 'img' : _c;
    var classNames = (0, classnames_1.default)(icon_secondary_module_scss_1.default['icon-secondary'], icon_secondary_module_scss_1.default["icon-secondary--".concat(size)], className);
    return (react_1.default.createElement("svg", { className: classNames, width: "1em", height: "1em", viewBox: "0 0 40 40", "aria-label": ariaLabel, "aria-hidden": ariaHidden, role: role }, children));
}
exports.default = Icon;
